import { StatePropertyRef } from '../../canvas/ExtendableStore';

export interface FollowersInfo {
    userIds: string[];
}
export const FollowersInfo = StatePropertyRef<FollowersInfo>('followers', { userIds: [] });
